import React from 'react';
import PropTypes from 'prop-types';

import styles from './eventRegForm.scss';
import { trackEvent } from '../Analytics/TrackedClick';
import { eventFlows, registrationUserOptions, regStepIds } from '../../utils/eventConstants';

const CampRegistrationSelection = ({ memberId, eventId, registrationTypeForCamps, setRegistrationTypeForCamps, setSidebarFlow, toStep, setSelectedDivisionIds, handleClearMultipleDivisionRegistrations }) => {
    const { SINGLE_PLAYER, MULTIPLE_PLAYERS } = registrationUserOptions;
    const isRegisteringForMultiplePlayers = registrationTypeForCamps === MULTIPLE_PLAYERS;
    const isRegisteringForMyself = registrationTypeForCamps === SINGLE_PLAYER;

    const handleSelectionChange = (event) => {
        setRegistrationTypeForCamps(event.target.value);
    };

    const handleSubmit = () => {
        const registrationType = isRegisteringForMultiplePlayers ? MULTIPLE_PLAYERS : SINGLE_PLAYER;
        trackEvent('Player Selected', { memberId, eventId, registrationType });

        if (isRegisteringForMultiplePlayers) {
            toStep(regStepIds.CAMP_DIVISION_SELECTION);
            setSidebarFlow(eventFlows.CAMP_FLOW);
            // make sure to clear out the selected division id's from the original flow to prevent any division mapping to old division registration
            setSelectedDivisionIds([]);
        } else {
            setSidebarFlow('');
            handleClearMultipleDivisionRegistrations();
            toStep(regStepIds.DIVISIONS);
        }
    };
    return (
        <div className={styles.registrationSelection}>
            <div className="mb16 text-black">Who are you registering for?</div>
            <div className={`radio-button radio-button-xl noselect ${isRegisteringForMyself ? 'checked' : ''}`}>
                <input
                    id="registerMyself"
                    type="radio"
                    name="registrationType"
                    value={SINGLE_PLAYER}
                    checked={isRegisteringForMyself}
                    onChange={handleSelectionChange}
                />
                <label htmlFor="registerMyself" className="radio-button-label">
                    <div className="radio-button-check">
                        {isRegisteringForMyself && <img src="/img/icons/checkmark-icon.svg" alt="checked" />}
                    </div>
                    <div className="radio-button-label mw0">
                        <div>Myself</div>
                    </div>
                </label>
            </div>
            <div className={`radio-button radio-button-xl noselect ${isRegisteringForMultiplePlayers ? 'checked' : ''}`}>
                <input
                    id="registerMultiple"
                    type="radio"
                    name="registrationType"
                    value={MULTIPLE_PLAYERS}
                    checked={isRegisteringForMultiplePlayers}
                    onChange={handleSelectionChange}
                />
                <label htmlFor="registerMultiple" className="radio-button-label">
                    <div className="radio-button-check">
                        {isRegisteringForMultiplePlayers && <img src="/img/icons/checkmark-icon.svg" alt="checked" />}
                    </div>
                    <div className="radio-button-label mw0">
                        <div>Multiple Players <span className="text-gray">{`(can include yourself)`}</span></div>
                    </div>
                </label>
            </div>
            <div className="fs12 text-black">
                Registrations may take time to appear on the player list if you're registering multiple players.
            </div>

            <button
                type="submit"
                className="btn btn-primary btn-xl btn-block mt24"
                onClick={handleSubmit}
            >
                Continue
            </button>
        </div>
    );
};

CampRegistrationSelection.propTypes = {
    memberId: PropTypes.number.isRequired,
    eventId: PropTypes.number.isRequired,
    toStep: PropTypes.func.isRequired,
    registrationTypeForCamps: PropTypes.string.isRequired,
    setRegistrationTypeForCamps: PropTypes.func.isRequired,
    setSidebarFlow: PropTypes.func.isRequired,
    setSelectedDivisionIds: PropTypes.func.isRequired,
    handleClearMultipleDivisionRegistrations: PropTypes.func.isRequired,
};

export default CampRegistrationSelection;
